<ng-container *ngIf="{ isOpen: isOpen$ | async } as context">
  <div
    class="collapsible-drawer"
    [ngClass]="{
      open: context.isOpen,
      'overflow-y-scroll': beta
    }">
    <div
      *ngIf="(isMobile$ | async) !== true && !alwaysExpanded"
      sbnb-resizer
      matTooltip="{{ context.isOpen ? 'Hide' : 'Show' }} Details"
      matTooltipPosition="left"
      direction="left"
      color="dark"
      [isExpanded]="context.isOpen"
      (onToggle)="toggleDrawer()"
      class="collapsible-drawer__resizer"></div>

    <ng-container *ngIf="context.isOpen">
      <div class="collapsible-drawer__header">
        <sbnb-close [border]="true" (click)="toggleDrawer()"></sbnb-close>
      </div>

      <div class="collapsible-drawer__content">
        <ng-content></ng-content>
      </div>
    </ng-container>
  </div>
</ng-container>
